<div class="flat-list-wrapper">
  <div class="message error" *ngIf="!isAuthenticated">
    Please log in first.
  </div>

  <section *ngIf="isAuthenticated" class="list-content">
    <div class="list-toolbar">
      <div class="message info" *ngIf="isLoading">{{ status }}</div>
      <div class="message subtle" *ngIf="!isLoading && !error">Limit: {{ activeFlatCount }}/{{ flatCreateLimit }}</div>
    </div>
    <div class="message error" *ngIf="error">{{ error }}</div>

    <app-entity-list
      *ngIf="!error"
      [loading]="isLoading"
      [list]="flatList"
      [deletedMode]="deletedMode"
      [tableHeaderAndValueKeySets]="tableHeaderAndValueKeySets"
      [emptyMessage]="'No flats found.'"
      [menuActions]="flatMenuActions"
      (cardClick)="onCardClickFromList($event)"
      (editClick)="onEditClickFromList($event)"
      (deleteClick)="onDeleteClickFromList($event)"
      (loadMore)="onLoadMoreFromList()"
    ></app-entity-list>
  </section>

  <div class="modal-overlay" *ngIf="isDetailsOpen && selectedFlat" (click)="closeDetailsModal()">
    <div class="details-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeDetailsModal()">
        &times;
      </button>
      <h3>Flat Details</h3>
      <div class="details-grid">
        <div class="details-item">
          <span class="label">Flat Name</span>
          <span class="value">{{ selectedFlat.flatName || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Floor Name</span>
          <span class="value">{{ selectedFlat.floorName || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">House</span>
          <span class="value">{{ selectedFlat.house?.houseName || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Pay Day</span>
          <span class="value">{{ selectedFlat.payDayTh || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Rent Amount</span>
          <span class="value">{{ selectedFlat.rentAmount || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Created On</span>
          <span class="value">{{ formatDateTime(selectedFlat.createdOn) }}</span>
        </div>
      </div>
      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeDetailsModal()">Close</button>
      </div>
    </div>
  </div>

  <app-new-edit-flat
    *ngIf="isEditOpen && flatForEdit"
    [mode]="'edit'"
    [initialFlat]="flatForEdit"
    (close)="closeEditModal()"
    (save)="onEditSave()"
  ></app-new-edit-flat>

  <app-confirm-action-modal
    [visible]="!!pendingDeleteFlat"
    [title]="'flat.deleteTitle' | t:'Delete Flat'"
    [message]="'flat.deleteMessage' | t:'Delete this flat?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [isLoading]="isDeleting"
    [danger]="true"
    (cancel)="closeDeleteModal()"
    (confirm)="confirmDeleteFlat()"
  ></app-confirm-action-modal>
</div>
